import React from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const Sustainability = () => {
  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Sustainability</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Sustainability</li>
          </ul>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "90px" }}>
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Sustainability at Hireme
        </h1>

        <img
          src="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/20px/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg"
          className="basic-page-header-image basic-page-paragraph-container"
          alt=""
          data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_0_5x/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg 390w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg 780w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_1_5x/s3/2024-07/farexbus-maxthrelfallphoto-13-landscape-sustainability.jpg 1170w"
          sizes="100vw"
        />

        {/*        <div id="section-43649" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container">
            <a
              href="https://content.presspage.com/uploads/2327/2b6fa6e7-a753-4cb7-9f37-a3eca6bab5f6/farex-esg-report-2023-mobile.pdf?10000="
              type="button"
              className="farex-btn farex-btn--has-icon farex-btn--secondary"
            >
              <farex-icon
                name="document"
                size="4"
                aria-hidden="true"
              ></farex-icon>
              <span className="farex-btn__text">Download full ESG Report 2023</span>
            </a>
          </div>
        </div> */}

        <div id="section-43650" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h2>Sustainability at Hireme</h2>
            <p>&nbsp;</p>
            <p>
              <em>
                “Sustainability is not an add on to our model. It is embedded in how Hireme is designed.”
              </em>
            </p>
            <p>
              Intercity road travel remains one of the most under optimised segments of mobility. Low vehicle occupancy, empty return trips, fragmented coordination, and growing fuel consumption contribute to rising carbon emissions and congestion. Hireme addresses this challenge at its structural root: utilisation.

            </p>

          </div>
        </div>

        <div id="section-43652" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Immediate Climate Impact</h3>
            <p>
              Our model increases vehicle occupancy across intercity corridors, reducing per capita carbon emissions from day one. By aggregating demand and enabling shared, commercially operated rides, we lower emissions per passenger kilometre without requiring new vehicle production.
            </p>
            <p>
              We also reduce empty return trips, a significant but often overlooked source of unnecessary fuel consumption. Higher utilisation means fewer redundant kilometres travelled, directly lowering fuel burn and associated emissions.
            </p>
            <p>Where feasible, we integrate cleaner fuels such as CNG to further reduce particulate matter and carbon intensity during the early stages of deployment.</p>
            <p>The result is measurable environmental outcomes including:</p>
            <ul>
              <li>Lower per-passenger CO₂ emissions</li>
              <li>Reduced vehicle kilometres per capita</li>
              <li>Improved fuel efficiency per trip</li>
              <li>Decreased congestion on high-traffic corridors</li>
              <li>Lower local air pollutant exposure in urban and peri-urban regions</li>
            </ul>
          </div>
        </div>

        <div id="section-43657" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h4>Systems-Level Sustainability</h4>
            <p>Beyond emissions, Hireme promotes behavioural and systemic shifts:</p>
            <ul>
              <li>Encouraging shared mobility over single-occupancy travel.</li>
              <li>
                Reducing the need for additional vehicle deployment
              </li>
              <li>
                Improving asset productivity across existing fleets
              </li>
              <li>
                Supporting driver income stability through better utilisation
                Sustainability, in this context, is not only environmental, it is economic and social.
              </li>
            </ul>
          </div>
        </div>

        <div id="section-43658" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Our Transition Pathway: Hybrid to Electric</h3>
            <p>
              Hireme operates with a phased decarbonisation strategy.
            </p>
            <p>
              <strong>Phase 1:</strong> Focuses on optimisation and cleaner fuels within existing infrastructure realities.<br />
              <strong>Phase 2:</strong> Progressively integrates electric vehicles across key intercity corridors.<br />
              <strong>Phase 3:</strong> Supports the development and adoption of corridor level charging infrastructure in partnership with ecosystem stakeholders.
            </p>
            <p>
              This transition approach ensures climate impact begins immediately while building toward deeper decarbonisation over time. Rather than waiting for full EV penetration, we design a pathway that is practical, scalable, and responsive to regional infrastructure maturity.
            </p>
            <h4>Alignment with the UN Sustainable Development Goals</h4>
            <p>Hireme contributes directly and indirectly to multiple SDGs:</p><br/>
            <h3>SDG 7 – Affordable and Clean Energy</h3>
            <p> By integrating cleaner fuels and transitioning toward electrification.</p>
            <h3>SDG 9 – Industry, Innovation and Infrastructure </h3>
            <p>Through technology-enabled corridor optimisation and scalable mobility systems.</p>
            <h3>SDG 11 – Sustainable Cities and Communities</h3>
            <p> By reducing congestion, improving intercity accessibility, and lowering emissions.</p>
            <h3>SDG 12 – Responsible Consumption and Production</h3>
            <p> By maximising utilisation of existing transport assets instead of increasing vehicle count.</p>
            <h3>SDG 13 – Climate Action</h3>
            <p> Through measurable reductions in per-capita transport emissions and a structured decarbonisation roadmap.</p>

            
          </div>
        </div>

        <div id="section-43660" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Our Commitment</h3>
            <p>
              Hireme is committed to tracking, measuring, and continuously improving the environmental performance of our operations. As we scale, we aim to implement transparent reporting mechanisms to quantify occupancy gains, emission reductions, and fuel transitions across corridors.
            </p>
            <p>
              Sustainability for us is not a marketing narrative. It is a design principle.
            </p>
            <p>By rethinking how intercity mobility functions, increasing efficiency before expanding capacity.  Hireme moves toward a future where travel is shared, optimised, and progressively decarbonised.</p>
          </div>
        </div>

        
      </div>
    </div>
  );
};
